import { useEffect, useState } from 'react';

export default function UpdateNotification() {

  const [show, setShow] = useState(false);
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const handler = e => {
      setRegistration(e.detail);   // aquí recibes el registration
      setShow(true);
    };
    window.addEventListener('swUpdated', handler);
    // ✅ Cuando el SW nuevo pasa a controlar la página, recarga
    const onControllerChange = () => {
      console.log('[SW] controllerchange -> recargando...');
      window.location.reload();
    };
    navigator.serviceWorker?.addEventListener('controllerchange', onControllerChange);
    // ✅ Alternativa/extra: si el SW manda mensaje “SW_ACTIVATED”, recarga
    const onMessage = (event) => {
      if (event.data?.type === 'SW_ACTIVATED') {
        console.log('[SW] SW_ACTIVATED -> recargando...');
        window.location.reload();
      }
    };
    navigator.serviceWorker?.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('swUpdated', handler);
      navigator.serviceWorker?.removeEventListener('controllerchange', onControllerChange);
      navigator.serviceWorker?.removeEventListener('message', onMessage);
    };
    // return () => window.removeEventListener('swUpdated', handler);
  }, []);

  const handleUpdate = () => {
    if (registration?.waiting) {
      console.log('>> Enviando SKIP_WAITING');
      registration.waiting.postMessage('SKIP_WAITING');
    } else {
      // fallback: si por alguna razón no hay waiting, intenta recargar
      window.location.reload();
    }
  };

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: '90%',
      background: '#2b2d42',
      color: '#fff',
      padding: '16px 24px',
      borderRadius: '8px',
      boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
      zIndex: 10000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '12px',
      textAlign: 'center'
    }}>
      <span style={{ fontSize: '1.1rem' }}>🔄 Nueva versión disponible</span>
      <button
        onClick={handleUpdate}
        style={{
          background: '#00b4d8',
          border: 'none',
          color: 'white',
          padding: '8px 16px',
          borderRadius: '6px',
          cursor: 'pointer',
          fontWeight: 'bold',
          fontSize: '1rem'
        }}
      >
        Actualizar
      </button>
    </div>
  );
}
